import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {ICom0108PState, IOffItemState, IComCdState} from '../../models/com/com0108p_model';
  
const initialState: ICom0108PState = {
    offItem : {
        cdGrpId : '',    // 휴가그룹ID
        cd      : '',    // 휴가구분코드
        cdNm    : '',    // 휴가구분명
        attr1   : 'N',   // 공가여부
        attr2   : '1',   // 반차여부
        useYn   : 'Y',   // 사용여부
    },
    halfOffDcdList : [],
    isEditMode : false,
}

export const com0108p_Slice = createSlice({
    name: "com0108p_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {
                ...initialState,
                halfOffDcdList: state.halfOffDcdList
            });
        },
        setOffItem: (state, action:PayloadAction<IOffItemState>) => {
            state.offItem = action.payload;
        },
        setHalfOffDcdList: (state, action:PayloadAction<IComCdState[]>) => {
            state.halfOffDcdList = action.payload;
        },
        setIsEditMode: (state, action:PayloadAction<boolean>) => {
            state.isEditMode = action.payload;
        },
    },
});

export default com0108p_Slice.reducer;
export const Com0108pAction  = com0108p_Slice.actions;
export const Com0108pReducer = com0108p_Slice.reducer;